import React , {useEffect , useState} from 'react'
import Image from 'next/image'
import Link from 'next/link'
import SectionHeading from '../../Common/SectionHeading'
import { limitText } from '../../Common/Functions'
import axios from 'axios'



export default function BlogSection() {
    const [data, setBlogList] = useState([])

    useEffect(() => {
        axios.get('https://www.delveinsight.com/blog/wp-json/wp-post/v1/latest').then((res) => {
            setBlogList(res.data)
        }).then((error) => {
        })
    }, [])

    return (
        <>
            {(data) &&
                <>
                    <div className="w-11/12 xl:max-w-screen max-w-screen-2xl flex flex-col justify-center mx-auto lg:my-10 my-6">
                        <SectionHeading
                            title="Latest news from the Blog"
                            shortDescription="The pharmaceutical and healthcare market is continuously changing and evolving owing to several facets, including new launches, unexpected failures, and unprecedented situations. Do not lose yourself in the ocean of information, and keep track of essential happenings through DelveInsight’s blogs. Subscribe to us for more information."
                        />
                        <div className='grid grid-cols-12 gap-4'>
                            {data?.map((item, index) => (
                                <div key={index} className='md:col-span-4 col-span-12'>
                                    <div className="group object-cover relative overflow-hidden transition-all duration-500 mb-0 cursor-pointer before:absolute before:left-0 before:bottom-0 before:w-full before:h-full before:bg-gradient-to-b before:from-black before:via-opacity-0 before:to-transparent before:transform before:-rotate-180 before:transition-all before:duration-500 before:z-10 before:rounded-lg">
                                        <div className="relative overflow-hidden rounded-lg">
                                            <Image priority={true}
                                                width={2000}
                                                height={2000}
                                                className='w-full lg:h-64 h-full object-cover group-hover:scale-110 transition-all duration-500 group-hover:duration-500'
                                                alt={item?.title ? item?.title : 'DelveInsight'}
                                                src={item?.image.replace(/-150x150/, '')}
                                            />
                                        </div>
                                        <div className="absolute block left-0 bottom-[-80px] z-10 p-5 group-hover:bottom-0 transition-all duration-500 group-hover:transition-all group-hover:duration-500 group-hover:delay-300">
                                            <Link href={process.env.APP_URL + '/blog/' +item?.post_name}>
                                                <h3 className="text-lg font-semibold text-white my-4">
                                                    {limitText(item?.title, 100)}
                                                </h3>
                                            </Link>
                                            <Link href={process.env.APP_URL + '/blog/' +item?.post_name} className="flex justify-center items-center w-14 h-14 bg-blue-600 rounded-full text-white text-center line-height-14 mx-auto arrow-btn" aria-label="arrow-btn">
                                                <i className="fa fa-long-arrow-right text-base"></i>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </>
            }
        </>
    )
}
